{
  "FormerRebel": "Antiguo rebelde",

  "PolicyLink": "Para obtener más información, consulta nuestra política de privacidad.",

  "NoMatchTitle": "Pagina de 404",
  "LittleLostPhrase": "Oh vaya. Parece que estás un poco perdido",
  "Go": "Ir",
  "back": "volver",
  "or": "o",
  "homeToYour": "Menú principal a tu",
  "profile": "perfil",
  "home": "Menú principal",
  "Explore": "Explorar,",
  "theySay": "ellos dicen...",
  "ItWillBeFun": "Será divertido,",

  "NoPermissionTitle": "Woop Woop.",
  "NoPermissionPhrase": "No se te permite ver esta página.",

  "rebellionStarted": "La rebelión ha comenzado.",
  "RebelsBreakRules": "Los rebeldes rompen las reglas que están destinadas a romperse.",
  "LookingForLostEntrepreneurs": "Buscamos emprendedores perdidos. ¿Has visto por dónde se fueron?",
  "inner-innovator": "Tu innovador interior esta dejándose ver",
  "PopcornAnyone": "Si los sueños son granos de maíz, RebelBase los hace estallar. Palomitas de maíz, ¿alguien?",
  "GotAnIdea": "¿Tienes una idea que arrojaste en tu cajón de basura que pensaste que podría esperar a más tarde? Más tarde está aquí."
}
